import { Validator } from 'fluentvalidation-ts';
import { fieldRequiredValidationMessage } from '../../../../validators/sharedValidators';
import { beAnInteger, beBetweenInclusive, beNumeric } from '../../../../validators/stringValidators';
import { BuildTypeCode } from '../../../projects/project';
import { UnitHeatSourceTypeCode } from '../quoteOrDesignFormData';

export type DesignManifoldDetailsFormModel = {
  flowTemperatureInDegreesCelsius: string;
  disableNumberOfPortsAndPipesPerPortCalculation: boolean;
  isMountedUpsideDown: boolean;
};

export const getInitialDesignManifoldDetailsFormModel = (
  unitHeatSourceTypeCode: UnitHeatSourceTypeCode | null,
  buildTypeCode: BuildTypeCode,
): DesignManifoldDetailsFormModel => ({
  flowTemperatureInDegreesCelsius:
    unitHeatSourceTypeCode === 'Boiler'
      ? '55'
      : unitHeatSourceTypeCode === 'HeatPump'
      ? buildTypeCode === 'NewBuild'
        ? '45'
        : '50'
      : '',
  disableNumberOfPortsAndPipesPerPortCalculation: false,
  isMountedUpsideDown: false,
});

export class DesignManifoldDetailsFormModelValidator extends Validator<DesignManifoldDetailsFormModel> {
  constructor(isDraft: boolean) {
    super();

    this.ruleFor('flowTemperatureInDegreesCelsius')
      .notEmpty()
      .withMessage(fieldRequiredValidationMessage)
      .must(beNumeric)
      .must(beAnInteger)
      .must(beBetweenInclusive(35, 60))
      .unless(() => isDraft);
  }
}
